import { createReducer } from 'redux-act';
import { setInternalValue, setBrandingColors, setCustomProfileFields } from './actions';

export default createReducer({
  [setInternalValue]: (state, internalValue) => ({ ...state, internalValue }),
  [setBrandingColors]: (state, brandingColors) => ({ ...state, brandingColors }),
  [setCustomProfileFields]: (state, customProfileFields) => ({ ...state, customProfileFields })
});
